<template>
  <div class="tree">
    <ul class="tree-list">
      <node-tree :node="treeData"></node-tree>
    </ul>
  </div>
</template>

<script>
import NodeTree from "./NodeTree.vue";

export default {
  data: function () {
    return {
    }
  },
  computed: {
    treeData() {
      return this.$store.getters.page.tree;
    },
  },
  mounted() {
    const el = document.querySelector('.catalog__sort');
    el.scrollIntoView({block: "start", inline: "center", behavior: "smooth"});
  },
  components: {
    NodeTree
  }
};
</script>

<style>
.tree-list ul {
  padding-left: 16px;
  margin: 6px 0;
}
</style>